module.exports = __webpack_public_path__ + "img/type-7.30476f3f.png";